module.exports = __webpack_public_path__ + "img/MEDIA038.459b4a51.jpg";